import "./about.css";

export function About({ paragraphs }: { paragraphs: string[] }) {
  return (
    <div className="about">
      {paragraphs.map((p) => (
        <p className="about__p" key={p}>
          {p}
        </p>
      ))}
    </div>
  );
}

